import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserSession } from '../models/user-session';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {

  constructor(private tokenService: TokenService) { }

  checkPermision(component: ActivatedRouteSnapshot): boolean {    
    return component.data.permissions.find((permise) =>
      this.tokenService.getDecodeToken().authorities.includes(permise)
    ) != null ? true : false;
  }
}
